export const InvalidApiVersionError = 'invalid-api-version';
export const InvalidIdentifierError = 'invalid-identifier';
